// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={128}
    height={115}
    viewBox="0 0 128 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M77.376 51.7651H0.875977V47.2651C0.875977 46.0717 1.35006 44.927 2.19397 44.0831C3.03788 43.2392 4.1825 42.7651 5.37598 42.7651H72.876C74.0694 42.7651 75.2141 43.2392 76.058 44.0831C76.9019 44.927 77.376 46.0717 77.376 47.2651V51.7651Z"
      fill="#FFB743"
    />
    <path
      d="M77.6748 51.7651H1.1748V47.2651C1.1748 46.0717 1.64888 44.927 2.4928 44.0831C3.33671 43.2392 4.48133 42.7651 5.6748 42.7651H73.1748C74.3683 42.7651 75.5129 43.2392 76.3568 44.0831C77.2007 44.927 77.6748 46.0717 77.6748 47.2651V51.7651Z"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M73.1748 103.527H5.6748C4.48133 103.527 3.33671 103.053 2.4928 102.209C1.64888 101.365 1.1748 100.22 1.1748 99.0269V51.7769H77.6748V99.0269C77.6748 100.22 77.2007 101.365 76.3568 102.209C75.5129 103.053 74.3683 103.527 73.1748 103.527Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M34.2158 61.2749H11.7158C10.4732 61.2749 9.46582 62.2823 9.46582 63.5249V92.7749C9.46582 94.0175 10.4732 95.0249 11.7158 95.0249H34.2158C35.4585 95.0249 36.4658 94.0175 36.4658 92.7749V63.5249C36.4658 62.2823 35.4585 61.2749 34.2158 61.2749Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M65.7158 74.7769H45.4658C44.2232 74.7769 43.2158 75.7842 43.2158 77.0269V92.7768C43.2158 94.0195 44.2232 95.0268 45.4658 95.0268H65.7158C66.9585 95.0268 67.9658 94.0195 67.9658 92.7768V77.0269C67.9658 75.7842 66.9585 74.7769 65.7158 74.7769Z"
      fill="#FFE9A4"
      stroke="#FF9D33"
      strokeLinejoin="round"
    />
    <path
      d="M43.4238 61.73H68.4238"
      stroke="#29292F"
    />
    <path
      d="M43.4238 69.4214H68.4238"
      stroke="#29292F"
    />
    <path
      d="M43.4238 65.5796H68.4238"
      stroke="#29292F"
    />
    <path
      d="M32.23 7.74492L32.6642 7.76012C34.4054 7.82401 36.05 8.57687 37.2363 9.85312C38.4226 11.1294 39.0534 12.8245 38.9901 14.5658L38.9727 15L38.9901 14.5658C39.0215 13.7035 39.2224 12.8559 39.5814 12.0713C39.9404 11.2866 40.4505 10.5805 41.0825 9.993C41.7145 9.40556 42.456 8.94838 43.2647 8.64757C44.0735 8.34677 44.9335 8.20823 45.7958 8.23988L46.23 8.25725L45.7958 8.23988C44.9335 8.20853 44.0859 8.0076 43.3013 7.64858C42.5166 7.28957 41.8104 6.77949 41.223 6.14749C40.6355 5.51549 40.1784 4.77395 39.8776 3.96523C39.5768 3.15651 39.4382 2.29645 39.4699 1.43418L39.4851 1L39.4699 1.43418C39.4385 2.29646 39.2376 3.14412 38.8786 3.92873C38.5195 4.71335 38.0095 5.41955 37.3775 6.00699C36.7455 6.59444 36.0039 7.05163 35.1952 7.35243C34.3865 7.65324 33.5264 7.79177 32.6642 7.76012L32.23 7.74492Z"
      fill="white"
      stroke="#29292F"
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M54.23 9.8178L54.5401 9.82865C55.7839 9.87429 56.9586 10.412 57.8059 11.3237C58.6533 12.2353 59.1039 13.4461 59.0586 14.6899L59.0462 15L59.0586 14.6899C59.081 14.074 59.2246 13.4685 59.481 12.908C59.7374 12.3476 60.1018 11.8432 60.5532 11.4236C61.0046 11.004 61.5343 10.6774 62.112 10.4626C62.6896 10.2477 63.3039 10.1487 63.9199 10.1713L64.23 10.1837L63.9199 10.1713C63.3039 10.1489 62.6985 10.0054 62.138 9.74899C61.5776 9.49255 61.0732 9.12821 60.6536 8.67678C60.234 8.22535 59.9074 7.69568 59.6925 7.11802C59.4777 6.54036 59.3787 5.92603 59.4013 5.31013L59.4122 5L59.4013 5.31013C59.3789 5.92604 59.2354 6.53151 58.979 7.09195C58.7225 7.65239 58.3582 8.15682 57.9068 8.57642C57.4553 8.99603 56.9257 9.32259 56.348 9.53745C55.7703 9.75231 55.156 9.85126 54.5401 9.82865L54.23 9.8178Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M29.23 28.3725L29.4471 28.3801C30.3177 28.412 31.14 28.7884 31.7332 29.4266C32.3263 30.0647 32.6417 30.9123 32.61 31.7829L32.6014 32L32.61 31.7829C32.6257 31.3518 32.7262 30.9279 32.9057 30.5356C33.0852 30.1433 33.3402 29.7902 33.6562 29.4965C33.9722 29.2028 34.343 28.9742 34.7474 28.8238C35.1517 28.6734 35.5818 28.6041 36.0129 28.6199L36.23 28.6286L36.0129 28.6199C35.5818 28.6043 35.1579 28.5038 34.7656 28.3243C34.3733 28.1448 34.0202 27.8897 33.7265 27.5737C33.4328 27.2577 33.2042 26.887 33.0538 26.4826C32.9034 26.0783 32.8341 25.6482 32.8499 25.2171L32.8575 25L32.8499 25.2171C32.8342 25.6482 32.7338 26.0721 32.5543 26.4644C32.3748 26.8567 32.1197 27.2098 31.8037 27.5035C31.4877 27.7972 31.117 28.0258 30.7126 28.1762C30.3082 28.3266 29.8782 28.3959 29.4471 28.3801L29.23 28.3725Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M127.124 34.3589H50.624V29.8589C50.624 28.6654 51.0981 27.5208 51.942 26.6769C52.7859 25.833 53.9305 25.3589 55.124 25.3589H122.624C123.817 25.3589 124.962 25.833 125.806 26.6769C126.65 27.5208 127.124 28.6654 127.124 29.8589V34.3589Z"
      fill="#FFB743"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M122.624 86.1108H55.124C53.9305 86.1108 52.7859 85.6367 51.942 84.7928C51.0981 83.9489 50.624 82.8043 50.624 81.6108V34.3608H127.124V81.6108C127.124 82.8043 126.65 83.9489 125.806 84.7928C124.962 85.6367 123.817 86.1108 122.624 86.1108Z"
      fill="#F9F9F9"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M113.622 32.1089C114.865 32.1089 115.872 31.1015 115.872 29.8589C115.872 28.6162 114.865 27.6089 113.622 27.6089C112.379 27.6089 111.372 28.6162 111.372 29.8589C111.372 31.1015 112.379 32.1089 113.622 32.1089Z"
      fill="#29292F"
    />
    <path
      d="M120.373 32.1089C121.616 32.1089 122.623 31.1015 122.623 29.8589C122.623 28.6162 121.616 27.6089 120.373 27.6089C119.13 27.6089 118.123 28.6162 118.123 29.8589C118.123 31.1015 119.13 32.1089 120.373 32.1089Z"
      fill="#29292F"
    />
    <path
      d="M84.3721 43.3608H61.8721C60.6294 43.3608 59.6221 44.3682 59.6221 45.6108V74.8608C59.6221 76.1035 60.6294 77.1108 61.8721 77.1108H84.3721C85.6147 77.1108 86.6221 76.1035 86.6221 74.8608V45.6108C86.6221 44.3682 85.6147 43.3608 84.3721 43.3608Z"
      fill="#F9F9F9"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M115.872 56.8618H95.6221C94.3794 56.8618 93.3721 57.8692 93.3721 59.1118V74.8618C93.3721 76.1044 94.3794 77.1118 95.6221 77.1118H115.872C117.115 77.1118 118.122 76.1044 118.122 74.8618V59.1118C118.122 57.8692 117.115 56.8618 115.872 56.8618Z"
      fill="#FFE9A4"
      stroke="#FF9D33"
      strokeLinejoin="round"
    />
    <path
      d="M93.5801 43.8169H118.58"
      stroke="#29292F"
    />
    <path
      d="M93.5801 51.5073H118.58"
      stroke="#29292F"
    />
    <path
      d="M93.5801 47.6655H118.58"
      stroke="#29292F"
    />
    <path
      d="M104.819 92.0142L105.747 90.4072L106.675 92.0142L104.819 92.0142Z"
      fill="#29292F"
      stroke="#29292F"
    />
    <path
      d="M105.747 92.5142C105.747 104.245 96.461 113.755 85.006 113.755C79.6887 113.755 74.8387 111.706 71.168 108.337"
      stroke="#29292F"
      strokeDasharray="3 3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.636 69.9207C105.519 69.9206 105.407 69.8742 105.325 69.7916L102.314 66.7753C102.287 66.748 102.265 66.7156 102.25 66.6798C102.235 66.6441 102.227 66.6057 102.227 66.567C102.227 66.5283 102.235 66.4899 102.25 66.4541C102.265 66.4184 102.287 66.3859 102.314 66.3587L102.725 65.942C102.752 65.9145 102.785 65.8927 102.82 65.8778C102.856 65.8629 102.894 65.8552 102.933 65.8552C102.972 65.8552 103.01 65.8629 103.046 65.8778C103.082 65.8927 103.114 65.9145 103.142 65.942L105.16 67.9666V61.9985C105.16 61.9207 105.191 61.846 105.246 61.791C105.301 61.736 105.376 61.7051 105.454 61.7051H106.04C106.118 61.7051 106.193 61.736 106.248 61.791C106.303 61.846 106.334 61.9207 106.334 61.9985V67.9666L108.353 65.942C108.379 65.9147 108.411 65.893 108.447 65.8782C108.482 65.8633 108.52 65.8557 108.558 65.8557C108.596 65.8557 108.634 65.8633 108.669 65.8782C108.705 65.893 108.737 65.9147 108.763 65.942L109.18 66.3587C109.208 66.3859 109.229 66.4184 109.244 66.4541C109.259 66.4899 109.267 66.5283 109.267 66.567C109.267 66.6057 109.259 66.6441 109.244 66.6798C109.229 66.7156 109.208 66.748 109.18 66.7753L106.17 69.7916C106.086 69.8731 105.975 69.9194 105.859 69.9207H105.636ZM111.029 69.0405V71.0944C111.029 71.4057 110.905 71.7042 110.685 71.9243C110.465 72.1444 110.166 72.2681 109.855 72.2681H101.639C101.328 72.2681 101.029 72.1444 100.809 71.9243C100.589 71.7042 100.466 71.4057 100.466 71.0944V69.0405C100.466 68.9627 100.496 68.888 100.552 68.833C100.607 68.778 100.681 68.7471 100.759 68.7471H101.346C101.424 68.7471 101.498 68.778 101.553 68.833C101.608 68.888 101.639 68.9627 101.639 69.0405V71.0944H109.855V69.0405C109.855 68.9627 109.886 68.888 109.941 68.833C109.996 68.778 110.07 68.7471 110.148 68.7471H110.735C110.813 68.7471 110.888 68.778 110.943 68.833C110.998 68.888 111.029 68.9627 111.029 69.0405Z"
      fill="#FF9D33"
    />
  </svg>
);
const SvgImportEdits = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgImportEdits;
